import {useNavigate} from 'react-router-dom'

import {usePipelineId} from '../../../../hooks/pipeline'
import useBooleanState from '../../../../hooks/useBooleanState'
import {pipelinesAppId} from '../../../../PipelinesPages.consts'
import {pipelinesApi} from '../../../../services/pipelinesApi'
import {usePipelineNameOrDraft} from '../../../EditPipelinePage.hooks'

import {getPipelinesHref} from 'src/routes'

export function usePipelineSettingsFooter() {
  const id = usePipelineId()
  const name = usePipelineNameOrDraft()
  const navigate = useNavigate()
  const portalTarget = document.getElementById(pipelinesAppId)

  const [isDialogShown, showDialog, hideDialog] = useBooleanState()

  const [deletePipeline, {isLoading}] = pipelinesApi.endpoints.deletePipeline.useMutation()
  const handlerConfirmDeletePipelineButtonClick = () => {
    deletePipeline(id).then(() => {
      navigate(getPipelinesHref())
    })
  }

  return {
    name,
    isLoading,
    portalTarget,
    isDialogShown,
    showDialog,
    hideDialog,
    handlerConfirmDeletePipelineButtonClick,
  }
}
